import React, {useState, useEffect } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
    Grid,
    Typography,
} from '@material-ui/core';
import {ButtonTextMUI as Button} from "utils/componentsStyle";
import {green, indigo} from "@material-ui/core/colors";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import api from "utils/API";
import apiform from "utils/APIForm";
import {setmessageGeneral } from "actions/getGlobalAction";

// Tarea genérica "DocumentoFaltante": se genera cuando, en cualquier punto del
// flujo posterior a la aprobación del coordinador, se detecta que falta un
// documento (ver Solicitud_Paciente.crear_tarea_documento_faltante). El tipo de
// documento a subir viaja en rowInfo.comentarios (mismo patrón que
// ModalUploadAutorizationPending usa con "isapre").
export default function ModalDocumentoFaltante({
    open,
    closeModal,
    rowInfo,
    setinitialCharge,
}) {
    const dispatch = useDispatch();
    const [listFile, setlistFile] = useState([]);
    const [documentoFile, setDocumentoFile] = useState(null);
    const [sending, setsending] = useState(false);

    const dictTypeRequest = useSelector(state => state.currentList.DICCIONARIO_TIPO_SOLICITUD_PACIENTE);
    const dictTypeFile = useSelector(state => state.currentList.DICCIONARIO_TIPO_ARCHIVO_PACIENTE);

    useEffect(() => {
        api.get(`api/documentospaciente/?tarea_paciente=${rowInfo.id}`).then(response => {
            setlistFile(response.data)
        });
    }, []);

    const handleSubir = () => {
        if (sending || documentoFile === null) {
            return;
        }
        setsending(true);
        const formData = new FormData();
        formData.append("archivo", documentoFile[0]);
        formData.append("tipo_documento", rowInfo.comentarios);
        formData.append("nombre_archivo", documentoFile[0].name);
        apiform.post(`/api/paciente/solicitudes/${rowInfo.id}/documentos/pendiente/subir/`, formData).then((response) => {
            setmessageGeneral(dispatch, response.data.mensaje, "success", "¡Éxito!");
            setinitialCharge(true)
            closeModal()
        }).catch(() => {
            setmessageGeneral(dispatch, "No se pudo subir el documento", "error", "Error");
            setsending(false);
        })
    }

    const handleDownloadFile = (link) => {
        window.open(link)
    }

    const patientData = rowInfo.id_ficha?.id_paciente
    const patientName = patientData ? `${patientData.nombre} ${patientData.apellido_paterno} ${patientData.apellido_materno}` : ""
    const typeRequest = dictTypeRequest[rowInfo?.id_solicitud_paciente?.Tipo_Solicitud_Paciente]

    const _content_ = <div>
        <Grid item container xs={12} justify="center" style={{margin: "10px 0"}}>
            <Typography variant="body1">
                <b>Paciente:</b> {patientName} — <b>Solicitud:</b> {typeRequest?.label} (#{rowInfo?.id_solicitud_paciente?.id})
            </Typography>
        </Grid>
        <Grid item container xs={12} justify="center" style={{margin: "10px 0"}}>
            <Typography variant="body1" style={{fontWeight: 'bold'}}>
                {`Falta adjuntar: ${dictTypeFile[rowInfo.comentarios]?.label || rowInfo.comentarios}`}
            </Typography>
        </Grid>

        {listFile.length > 0 &&
        <Grid item container xs={12} justify="center" style={{margin: "10px 0"}}>
            {listFile.map((row) => (
                <Grid item xs={12} key={row.id}>
                    <Button
                        variant="outlined"
                        color="primary"
                        title={`Descargar ${dictTypeFile[row.tipo_documento]?.label || row.tipo_documento}: ${row.nombre_archivo}`}
                        style={{margin: "5px", width: "100%", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "none"}}
                        onClick={() => handleDownloadFile(row.archivo)}
                    >
                        {`Descargar ${dictTypeFile[row.tipo_documento]?.label || row.tipo_documento}: ${row.nombre_archivo}`}
                    </Button>
                </Grid>
            ))}
        </Grid>
        }

        <Grid item container xs={12} justify="center" alignItems="center" style={{margin: "10px 0"}}>
            <Button
                variant="contained"
                component="label"
                color="primary"
                style={{ textTransform: "none", marginRight: "10px" }}
            >
                {documentoFile === null ? "Seleccionar archivo" : documentoFile[0]?.name}
                <input
                    type="file"
                    onChange={(event) => setDocumentoFile(event.target.files)}
                    hidden
                    accept={("pdf", "jpg", "jpeg", "png")}
                />
            </Button>
        </Grid>
    </div>

    const _actions_ = <>
        <Button
            disabled={sending || documentoFile === null}
            variant="contained"
            style={{backgroundColor: sending || documentoFile === null ? "#dddddd" : green[500]}}
            className="text-white"
            onClick={handleSubir}
        >
            {sending ? "Subiendo..." : "Subir documento"}
        </Button>
        <Button
            mr={2}
            variant="contained"
            style={{backgroundColor: indigo[500]}}
            className="text-white"
            onClick={closeModal}
        >
            Cerrar
        </Button>
    </>

    return (
        <ModalDialog
            open={open}
            onClose={closeModal}
            title={`Documento faltante`}
            _content_={_content_}
            _actions_ = {_actions_}
            maxWidth="sm"
        />
    );
}
